import useScreenSize from "hoc/useScreenSize";
import useSafeRouter from "../../hoc/useSafeRouter";
import { TIER_MAKE_MODEL_PAGES } from "../../util/product/product-constants";
import PAPagination from "../design-system/PAPagination";
import { DESKTOP_ITEM_COUNT } from "../../util/category/category-utils";
import styles from "./categoryPagination.module.scss";

function CategoryPagination(props: any) {
  const {
    productList, currentPage, onSelectPage, pageSize = DESKTOP_ITEM_COUNT, pageType,
  } = props;

  const [, , isDesktop] = useScreenSize();

  const router = useSafeRouter();
  const { pathname } = router.query;
  // https://www.wrike.com/open.htm?id=604886150
  const useLinks = pageType && TIER_MAKE_MODEL_PAGES.includes(pageType);

  if (productList.products && productList.products.length > 0) {
    const totalPages = Math.ceil(productList.totalHits / pageSize);
    if (totalPages === 1) {
      return null;
    }
    return (
      <PAPagination
        className="pull-right"
        containerClassName={styles.pa_pagination_className}
        next
        prev
        activePage={currentPage}
        maxButtons={isDesktop ? 5 : 3}
        items={totalPages}
        onSelect={onSelectPage}
        pagePath={useLinks ? pathname : undefined}
      />
    );
  }
  return <span />;
}

export default CategoryPagination;
